export enum CallsTypes {
  ScheduledFamilyCall = "Scheduled family call",
  ScheduledResidentCall = "Scheduled resident call",
  RealtimeFamilyCall = "Realtime family call",
  Call = "Call"
}